import { SearchModes } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

type ParamNames = string[];

export const PARAMS_NAMES = {
  HO: [
    URLParameters.DESTINATION,
    URLParameters.DATE_TO,
    URLParameters.DATE_FROM,
    URLParameters.SEARCH_MODE,
    URLParameters.ADULTS,
  ],
  DP: [
    URLParameters.DESTINATION,
    URLParameters.DATE_TO,
    URLParameters.DATE_FROM,
    URLParameters.SEARCH_MODE,
    URLParameters.ADULTS,
    URLParameters.ORIGIN,
  ],
  TH: [
    URLParameters.DESTINATION,
    URLParameters.DATE_TO,
    URLParameters.DATE_FROM,
    URLParameters.SEARCH_MODE,
    URLParameters.ADULTS,
    URLParameters.ORIGIN,
  ],
  FF: [],
};

// TODO: Current logic is default to HO param names, but we should also map FF param names and do `PARAMS_NAMES[searchMode]`
export const getParamNamesBySearchMode = (searchMode: SearchModes): ParamNames => {
  switch (searchMode) {
    case SearchModes.DP:
      return PARAMS_NAMES.DP;
    case SearchModes.HO:
      return PARAMS_NAMES.HO;
    case SearchModes.TH:
      return PARAMS_NAMES.TH;
    case SearchModes.FF:
      return PARAMS_NAMES.FF;
    default:
      return PARAMS_NAMES.HO; // TODO: is this correct as default?
  }
};

const isUndefinedOrEmpty = (value: unknown) => value === undefined || value === '' || value === null;

export const anyParamsEmptyOrUndefined = (query: SearchParams, paramNames: ParamNames): boolean =>
  paramNames.some((paramName) => isUndefinedOrEmpty(query[paramName]));

export const hasMissingParams = (query: SearchParams): boolean => {
  const paramNames = getParamNamesBySearchMode(query.searchMode as SearchModes);
  return anyParamsEmptyOrUndefined(query, paramNames);
};

export const hasAllMandatoryParams = (query: SearchParams): boolean => {
  const paramNames = getParamNamesBySearchMode(query.searchMode as SearchModes);
  return !anyParamsEmptyOrUndefined(query, paramNames);
};

export const hasAllMandatoryUrlSearchParams = (searchParams: URLSearchParams): boolean => {
  const paramNames = getParamNamesBySearchMode(searchParams.get(URLParameters.SEARCH_MODE) as SearchModes);
  return !anyParamsEmptyOrUndefined(Object.fromEntries(searchParams.entries()), paramNames);
};
